import { io } from "socket.io-client";
import * as mediasoupClient from "mediasoup-client";

class MediasoupService {
  constructor() {
    this.socket = null;
    this.device = null;
    this.roomId = null;
    this.transports = {
      send: null,
      recv: null,
    };
    this.producers = [];
    this.consumers = [];
  }

  async init({ serverUrl }) {
    // Initialize the socket.io client connection
    this.socket = io(serverUrl, {
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      autoConnect: false,
      transports: ["websocket", "polling"], // Ensure compatibility
      withCredentials: true,
    });

    return new Promise((resolve, reject) => {
      this.socket.connect();

      this.socket.on("connect", async () => {
        try {
          this.device = new mediasoupClient.Device();
          console.log("✅ Connected to server via socket:", this.socket.id);
          resolve();
        } catch (err) {
          console.error("❌ Mediasoup device init failed:", err);
          reject(err);
        }
      });

      this.socket.on("connect_error", (error) => {
        console.error("❌ Socket connection error:", error.message);
        reject(new Error(`Socket connection failed: ${error.message}`));
      });

      this.socket.on("disconnect", () => {
        console.warn("⚠️ Socket disconnected");
      });
    });
  }

  async createRoom() {
    if (!this.socket?.connected) {
      throw new Error("Socket not connected");
    }

    return new Promise((resolve, reject) => {
      this.socket.emit("createRoom", (response) => {
        if (response?.error) {
          reject(new Error(response.error));
        } else {
          this.roomId = response.roomId;
          console.log("🆕 Room created:", response.roomId);
          resolve(response.roomId);
        }
      });
    });
  }

  async joinRoom(roomId) {
    if (!this.socket?.connected) {
      throw new Error("Socket not connected");
    }

    return new Promise((resolve, reject) => {
      this.socket.emit("joinRoom", { roomId }, (response) => {
        if (response?.error) {
          reject(new Error(response.error));
        } else {
          console.log("👥 Joined room:", roomId);
          this.roomId = roomId;
          resolve();
        }
      });
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log("🔌 Socket manually disconnected");
    }
  }

  // You can add more WebRTC-specific methods here
}

const mediasoupService = new MediasoupService();
export default mediasoupService;
